<template>
	<v-card>
		<BidderEvaluationList/>
	</v-card>
</template>

<script>
	import BidderEvaluationList from "./BidderEvaluationList";

	export default {
		name: "BidderEvaluationView",
		components: {
			BidderEvaluationList
		}
	};
</script>

<style scoped>

</style>
